module.exports = __webpack_public_path__ + "static/media/13.45fdbe3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/13.png
// module id = 1343
// module chunks = 0